import { EventSourceHandler } from '@sellsy/sse';

export default class ExportFinishedEventSourceHandler extends EventSourceHandler {
    
    constructor(){
        super()
        this.type = 'staff.export.finished'
    }

    handle(event){
        console.log(event);
        window.Push.permanentSuccess("Votre fichier d'export est prêt à être téléchargé en cliquant ici", "Export prêt", [], function(){
            window.open(event.data.url, '_blank');
        });
    }

}